/**
 * Verifies the given path doesn't contain funky chars
 * @param path The path to check
 * @returns boolean
 */
export const isValidUrl = (path: string) => {
  return /^[a-z0-9/-]+$/i.test(path)
}
